import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  right: 0,
  bottom: 0,
  zIndex: 99999,
  width: '100%',
  height: '100%',
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.background.default,
}));

// ----------------------------------------------------------------------

LoadingScreen.propTypes = {
  isDashboard: PropTypes.bool,
};

export default function LoadingScreen({ isDashboard, ...other }) {
  return (
    <>
      {!isDashboard && (
        <RootStyle {...other}>

            {/* Image with Breathing Animation */}
            <Box
              sx={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                width: '100vw', // Adjust width of your logo
                height: '100vh', // Adjust height of your logo
                animation: 'breathing 2s ease-in-out infinite', // Breathing animation
              }}
            >
              <img src="/assets/Factor6_Blue.png" alt="Factor6 Loading" />
            </Box>

          {/* Keyframe animation */}
          <style>
            {`
              @keyframes breathing {
                0% {
                  transform: scale(1);
                }
                50% {
                  transform: scale(1.1);
                }
                100% {
                  transform: scale(1);
                }
              }
            `}
          </style>
        </RootStyle>
      )}
    </>
  );
}
